import React from "react";
import {Icon, IconProps} from "@tabler/icons-react";

export type TablerIconsType = React.ForwardRefExoticComponent<Omit<IconProps, "ref"> & React.RefAttributes<Icon>>;

interface ComboButtonProps {
    children?: React.ReactNode,
    onClick?: () => void,
    Icon: TablerIconsType,
    type?: 'button' | 'submit' | 'reset',
    disabled?: boolean,
    btnClass?: string,
}

export const ComboButton: React.FC<ComboButtonProps> = (
    {
        children,
        onClick,
        Icon,
        type = 'button',
        disabled = false,
        btnClass
    }) => {
    if (type === 'button' && !onClick) {
        throw new Error('Non hai specificato la property onClick');
    }
    return (
        <button
            type={type}
            onClick={() => onClick ? onClick() : () => {
            }}
            disabled={disabled}
            className={`mx-1 btn-combo-blue ${btnClass}`}
        >
            <Icon className="h-4 w-4 text-white" aria-hidden="true"/>{children}
        </button>
    )
}